import { memo, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { parse } from 'hub-http/helpers/params';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { EditIcon } from 'foundations-assets';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { getCallBody, getCRMObjectId, getResult, isResultSuccessful } from '../call-message/operators/callMessageGetters';
import CallMetadataError from './CallMetadataError';
import CallNotesTextEditor from './CallNotesTextEditor';
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MutableCallNotes = ({
  callMessage,
  handleEngagementDataUpdated,
  message,
  resetCallMessage
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const callBody = getCallBody(callMessage);
  const callBodyResult = callBody && getResult(callBody);
  const [previewTextHtmlString, setPreviewTextHtmlString] = useState(callBodyResult);
  const engagementId = getCRMObjectId(callMessage);
  const messageId = getId(message);
  const history = useHistory();
  const parser = new DOMParser();
  const previewTextFullHtml = parser.parseFromString(previewTextHtmlString, 'text/html');
  const previewTextBodyHtml = previewTextFullHtml.body;
  const previewText = previewTextBodyHtml.innerText;
  useEffect(() => {
    setPreviewTextHtmlString(callBodyResult);
  }, [callBodyResult]);
  useEffect(() => {
    const queryParams = parse(history.location.search.substring(1));
    if (queryParams && queryParams.focusCallNotesEditor && queryParams.messageId === messageId) {
      setIsEditing(true);
      return () => {
        history.replace({
          search: ''
        });
      };
    }
  }, [history, messageId]);
  if (!isResultSuccessful(callBody)) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CallMetadataError, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "conversations-calling-message.timeline-call-metadata.call-notes.error_jsx",
          options: {
            onClick: resetCallMessage
          },
          elements: {
            UILink: Link
          }
        })
      }), /*#__PURE__*/_jsx(Spacer, {
        space: "300"
      })]
    });
  }
  const handleToggleTextEditor = () => {
    setIsEditing(!isEditing);
    setIsHovering(false);
  };
  const handleMouseEnter = () => {
    setIsHovering(true);
  };
  const handleMouseLeave = () => {
    setIsHovering(false);
  };
  return isEditing ? /*#__PURE__*/_jsx(CallNotesTextEditor, {
    engagementId: engagementId,
    handleEngagementDataUpdated: handleEngagementDataUpdated,
    previewTextHtmlString: previewTextHtmlString,
    setIsEditing: setIsEditing
  }) : /*#__PURE__*/_jsx(View, {
    "data-test-id": "call-notes",
    onClick: handleToggleTextEditor,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsxs(View, {
      backgroundColor: isHovering ? 'fill-accent-blue-subtle' : undefined,
      borderWidth: isHovering ? '100' : undefined,
      borderStyle: isHovering ? 'solid' : undefined,
      borderColor: isHovering ? 'border-interactive-default' : undefined,
      borderRadius: isHovering ? '100' : undefined,
      cursor: isHovering ? 'text' : undefined,
      padding: isHovering ? '200' : undefined,
      position: isHovering ? 'relative' : undefined,
      children: [isHovering && /*#__PURE__*/_jsx(View, {
        insetBlockEnd: "0",
        insetInlineEnd: "0",
        paddingBlockEnd: "200",
        paddingInlineEnd: "200",
        position: "absolute",
        children: /*#__PURE__*/_jsx(EditIcon, {
          "data-test-id": "edit-notes-icon",
          color: "icon-interactive-default"
        })
      }), previewTextHtmlString && previewText.length > 0 ? /*#__PURE__*/_jsx(SanitizedText, {
        body: previewTextHtmlString
      }) : /*#__PURE__*/_jsx(Text, {
        color: "border-core-hover",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.call-notes-editor.add-notes-placeholder"
        })
      })]
    })
  });
};
export default /*#__PURE__*/memo(MutableCallNotes);